import { IDataContextProvider } from "@contexts/data/types";

export const addressService = (dataProvider: IDataContextProvider) => ({
  getPostalSuburb: async (postcodeOrSuburb: string) => {
    const baseUrl = dataProvider.getApiUrl();

    return await dataProvider
      .custom?.({
        method: "get",
        url: `${baseUrl}/address/PostalSuburb?postcodeorsuburb=${postcodeOrSuburb}`,
      })
      .then((result) => {
        return result?.data;
      });
  },
});
